import React from 'react'
import { string, func, number } from 'prop-types'
import classNames from 'classnames'
import Label from './label'

const TextArea = ({
  label,
  description,
  placeholder = '',
  value = '',
  maxLength,
  fieldName,
  errorMessage,
  onValueChange,
  classes = ''
}) => {
  const containerClasses = classNames('nft-field', { 'has-error': !!errorMessage }, classes)
  return (
    <div className={containerClasses}>
      {label && <Label text={label} labelFor={`user-${fieldName}`} description={description} />}
      <textarea
        className='afd-textfield__textarea'
        placeholder={placeholder}
        id={`user-${fieldName}`}
        name={`user-${fieldName}`}
        onChange={e => onValueChange(e.currentTarget.value)}
        data-insights-funnel-step={fieldName}
        value={value}
        maxLength={maxLength} />
      <p className='nft-textarea__feedback'>
        {errorMessage && <span className='nft-error-msg'>{errorMessage}</span>}
        {maxLength && <span className='nft-textarea__characters'>{value.length}/{maxLength}</span>}
      </p>
    </div>
  )
}

TextArea.propTypes = {
  label: string,
  description: string,
  placeholder: string,
  value: string,
  maxLength: number,
  fieldName: string.isRequired,
  errorMessage: string,
  onValueChange: func.isRequired,
  classes: string
}

export default TextArea